import { render, staticRenderFns } from "./zws-steps2.vue?vue&type=template&id=bdabe09a&scoped=true"
import script from "./zws-steps2.vue?vue&type=script&lang=js"
export * from "./zws-steps2.vue?vue&type=script&lang=js"
import style0 from "./zws-steps2.vue?vue&type=style&index=0&id=bdabe09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdabe09a",
  null
  
)

export default component.exports